import { render, staticRenderFns } from "./seller-questionnaire.vue?vue&type=template&id=fe04af3c&"
import script from "./seller-questionnaire.vue?vue&type=script&lang=js&"
export * from "./seller-questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./seller-questionnaire.vue?vue&type=style&index=0&id=fe04af3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports